import Homecontent from "./data/homecontent";
import { Topheader } from "./common/topheader";
import astro from "./images/services/finance.jpg";
import { Innerbanner } from "./common/innerbanner";
import {Footer} from './common/footer';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhoneSquare } from "@fortawesome/free-solid-svg-icons";
function  Finance(props2){


    return(
<div>
<Topheader></Topheader>
<Innerbanner title={"Business and Finance Astrolgy Guidance "}></Innerbanner>

<div className="container-fluid">

    <div className="container">
<div className="d-flex flex-column flex-sm-row flex-lg-row flex-md-row">

    <div className="bg-light shadow p-3 m-3 flex-fill"><img  src={astro } alt="famous astrologer Gurgaon" className="img-fluid float-start m-3"></img>
   <p> 
   Astrology can offer valuable insights into business ventures and financial management by analyzing your birth chart. Here’s how Astrologer Sanjay Bhargav can help with these aspects
   </p>  
<p>
<span className="fw-bolder">Identifying Suitable Business Ventures: </span> Analyzing the 10th house (career) and the planets influencing it can help determine the best types of businesses that align with your strengths and interests.</p><p>
<span className="fw-bolder">Timing for Business Launch:</span> Astrologers Sanjay Bhargav can identify auspicious times for starting new business ventures by examining planetary transits and Dasha periods, enhancing the potential for success.</p>
<p>
<span className="fw-bolder">Partnerships and Collaborations:</span>  For those considering entrepreneurship, astrologers offer insights into the most favorable times to launch a business, including potential partnerships and investment opportunities.</p><p>
<span className="fw-bolder">Market Trends and Opportunities</span> Astrology can help you navigate market trends by understanding planetary influences that may affect your industry or business sector.</p>
<p>
<span className="fw-bolder">Wealth Accumulation</span>  Evaluating the 7th house (partnerships) can provide insights into potential business partners, ensuring a harmonious and profitable collaboration.
</p>

<p>
<span className="fw-bolder">Remedies for Career Obstacles</span>  If you face financial challenges, astrologers can suggest specific remedies, such as wearing gemstones, chanting specific mantras, or performing rituals to mitigate negative influences and attract prosperity.</p>
<p>Astrological insights can be a powerful tool to guide you through your business and financial endeavors, helping you make well-informed decisions and achieve your goals.</p>
<p className="text-center"><h6>Curious about a specific aspect of your business or financial life?</h6><a href='https://api.whatsapp.com/send?phone=919873336259&text='><button className="btn btn-danger">I'm here to assist!</button></a></p>
    </div>


</div>


    </div>



</div>
<Footer></Footer>









</div>






 );







    
}
export {Finance} ;